import { render, staticRenderFns } from "./ComboResults.vue?vue&type=template&id=1298371c&scoped=true&"
import script from "./ComboResults.vue?vue&type=script&lang=js&"
export * from "./ComboResults.vue?vue&type=script&lang=js&"
import style0 from "./ComboResults.vue?vue&type=style&index=0&id=1298371c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298371c",
  null
  
)

export default component.exports